module.exports = __webpack_public_path__ + "static/media/Virginia Chan.2c58c48e.png";